const isObject = (obj) =>
    obj === Object(obj) && Object.prototype.toString.call(obj) !== '[object Array]';

const isEmpty = (value) => {
    switch (typeof value) {
        case 'string':
            return value.trim() === '';
        case 'undefined':
            return true;
        case 'object':
            return value === null;
        default:
            return false;
    }
};

const removeEmptyValues = (obj) => Object.keys(obj).reduce((acc, key) => {
    if (!isEmpty(obj[key])) {
        return {
            ...acc,
            [key]: obj[key]
        };
    }

    return acc;
}, {});

const convertSlugToText = (slug) => slug.replace(/-/g, ' ');

// null-safe get (similar to _.get)
const getOr = (obj, path, fallback = null) =>
    path
        .split('.')
        .reduce((acc, key) => {
            if (acc === fallback || !isObject(acc)) {
                return fallback;
            }

            return acc[key] || fallback;
        }, obj);

module.exports = {
    isObject,
    removeEmptyValues,
    convertSlugToText,
    getOr
};
